export default __webpack_public_path__ + "static/media/SansWeb-Light.1338f2fc.woff";